module.exports = __webpack_public_path__ + "static/img/67066E_2_3_C_20200612_LC.3083f2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/67066E_2_3_C_20200612_LC.png
// module id = DjcV
// module chunks = 0